import { User } from "./user.interface";

export interface ItemType {
  itemType_ID: number;
  dealer_ID: number;
  itemType_Desc: string;
  itemType_Parent: number;
  itemType_IsAccessory: boolean;
  itemType_IsActive: boolean;
  itemType_CreatedBy: string;
  itemType_Created: string;
  itemType_ModifiedBy: string;
  itemType_Modified: string;
  itemType_IsUsage: boolean;
  itemCoverageType_ID: ItemCoverageType;
  itemType_Postinstructions: string;
  itemType_Preinstructions: string;
  type: string;

  itemCoverageType: ItemCoverageTypes
  createdBy: User
}

export enum ItemCoverageType {
  Blow = 1,
  Inches = 2,
  AeroBarrier = 3
}

export interface ItemCoverageTypes {
  itemCoverageType_ID: number;
  itemCoverageType_Desc: string;
}
